import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import { Link } from "react-router-dom";
import { Offcanvas, Dropdown, Button } from "react-bootstrap";
import MobLeftbar from "./MobLeftbar";
import GamesSearchModal from "../views/components/GamesSearchModal";
import numberWithCommas from "../utils/numbersWithComma";

import MenuIcon from "../assets/images/settings.png";
import LogoutIconImg from "../assets/images/logoutnew.png";
import MenuIconNew from "../assets/images/menu-button.png";
import UserIcon from "../assets/images/user-icon.png";
import WalletIcon from "../assets/svg/WalletIcon";
import BetIcon from "../assets/images/BetIcon.png";
import AcStatement from "../assets/images/AcStatement.png";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import logo from "../assets/images/logoNew.webp";
import BonusImg from "../assets/images/bonus.png";
import refferal from "../assets/images/refferal.png";

import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";

const HeaderAfterLogin = () => {
  const { user, balance, wallet } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const handleClose = () => setShow(false);
  const handleShow1 = () => setShow1(!show1);
  const dispatch = useDispatch();
  const [isClassAdded, setIsClassAdded] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      setIsClassAdded(true);
      document.body.classList.add("light-theme");
    }
  }, []);
  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  const options = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const formattedDateTime = currentDateTime.toLocaleString("en-US", options);

  const htmlElement = document.documentElement;
  useEffect(() => {
    if (show1) {
      htmlElement.style.overflow = "hidden";
    } else {
      htmlElement.style.overflow = "auto";
    }
  }, [show1]);

  // console.log("balance", wallet);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  const headerPages = [
    "/sports-lobby/agse",
    "/sportsbook/Inplay",
    "/sportsbook/Cricket",
    "/sportsbook/Soccer",
    "/sportsbook/Tennis",
    "/atlas-lobby",
    "/livecasino",
    "/pragmaticplay",
  ];

  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f),
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header afterlogin">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center">
                <Button
                  variant="primary menu-btn"
                  onClick={handleShow1}
                  className="d-block d-md-none"
                >
                  <img src={MenuIconNew} alt="User Menu Icon" width={25} />
                </Button>

                <div className="logo">
                  <a href="/sports">
                    {/* <img src={appDetails?.LOGO_URL} alt="Logo" /> */}
                    <img src={logo} alt="Logo" />
                  </a>
                  {/* <div className="dateTime">
                    <span>{formattedDateTime}</span>
                    <span class="country-standred-time">(+05:30)</span>
                  </div> */}
                </div>

                <GamesSearchModal />

                <div className="headerRight ms-auto">
                  <ul>
                    <a
                      href="/depositgatways/deposits"
                      className="WithDrawHeader"
                    >
                      <span className="d-none d-sm-block">Deposit</span>
                      <span className="d-sm-none">D</span>
                    </a>
                    <a
                      href="/depositgatways/withdraw"
                      className="WithDrawHeader withdraw"
                    >
                      Withdraw
                    </a>

                    <li className="balance">
                      <div className="balance-amount" href="/cashier">
                        <span className="d-sm-none">
                          Bal: {wallet?.balance}
                        </span>
                        <span className="d-none d-sm-block">
                          Balance: {wallet?.balance}
                        </span>
                        <span className="d-md-block d-none">
                          Bonus: {numberWithCommas(wallet?.coins)}
                        </span>
                      </div>
                    </li>
                  </ul>

                  <Dropdown className="HomeDropdown">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <img src={MenuIcon} alt="User Menu Icon" width={25} />
                      <span>Account</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item href="/profile">
                        <div className="d-flex">
                          <div className="profile-img">
                            <img src={UserIcon} alt="User Icon" />
                          </div>
                          <div className="user-info">
                            <Link className="user_name" to="/profile">
                              {user?.mstruserid}
                            </Link>
                            <p>{user?.mobileno}</p>
                          </div>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item href="javascript:void(0)">
                        <div className=" upperbalnace">
                          <div className="balance">
                            <div className="">
                              <WalletIcon />
                              Balance
                            </div>
                            <div className="balance-amount ">
                              BDT {wallet?.balance}
                            </div>
                          </div>
                          <div className="balance">
                            <div
                              className=""
                              onClick={() => {
                                navigate("/depositgatways/withdraw");
                              }}
                            >
                              <Button variant="" className="btn_withdraw">
                                Withdraw
                              </Button>
                            </div>
                            <div
                              className=""
                              onClick={() => {
                                navigate("/depositgatways/deposits");
                              }}
                            >
                              <Button
                                variant="primary"
                                className="btn_withdraw"
                              >
                                Deposit
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Item href="/mybets">My Bets</Dropdown.Item>
                      <Dropdown.Item href="/bonus">Bonus</Dropdown.Item>
                      <Dropdown.Item href="/referral">Referral</Dropdown.Item>
                      <Dropdown.Item href="/cashier">
                        Account Statement
                      </Dropdown.Item>
                      <Dropdown.Item
                        className="d-md-none d-block"
                        href="#"
                        onClick={() => dispatch(logoutUser())}
                      >
                        Sign Out
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <ul className="LogoutUSer d-md-block d-none">
                    <li onClick={() => dispatch(logoutUser())}>
                      <a href="#">
                        <img src={LogoutIconImg} />
                        <span>Sign Out</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="btmHead">
          <ul>
            <li>
              <a
                href="/sportsbook/Inplay"
                className={activePage === "/sportsbook/Inplay" ? "active" : ""}
              >
                Exchange
              </a>
            </li>
            <li>
              <a
                href="/sports-lobby/agse"
                className={activePage === "/sports-lobby/agse" ? "active" : ""}
              >
                Exchange 2
              </a>
            </li>
            <li>
              <a
                href="/sportsbook/Cricket"
                className={activePage === "/sportsbook/Cricket" ? "active" : ""}
              >
                Cricket
              </a>
            </li>
            <li>
              <a
                href="/sportsbook/Soccer"
                className={activePage === "/sportsbook/Soccer" ? "active" : ""}
              >
                Football
              </a>
            </li>
            <li>
              <a
                href="/sportsbook/Tennis"
                className={activePage === "/sportsbook/Tennis" ? "active" : ""}
              >
                Tennis
              </a>
            </li>
            <li>
              <a
                href="/livecasino"
                className={activePage === "/livecasino" ? "active" : ""}
              >
                Live Casino
              </a>
            </li>
            <li>
              <a
                href="/slots"
                className={activePage === "/slots" ? "active" : ""}
              >
                Slots Games
              </a>
            </li>
            <li>
              <a
                href="/jilli"
                className={activePage === "/jilli" ? "active" : ""}
              >
                Jilli Games
              </a>
            </li>
            <li>
              <a
                href="/kingmaker"
                className={activePage === "/kingmaker" ? "active" : ""}
              >
                Kingmaker Games
              </a>
            </li>

            <li>
              <a
                href="/pragmaticplay"
                className={activePage === "/pragmaticplay" ? "active" : ""}
              >
                Pragmatic Play Games
              </a>
            </li>
            <li>
              <a
                href="/sports-lobby/ig_pixel"
                className={
                  activePage === "/sports-lobby/ig_pixel" ? "active" : ""
                }
              >
                Sportsbook2
              </a>
            </li>
          </ul>
        </div>

        <Offcanvas
          className="user_section"
          show={show}
          onHide={handleClose}
          placement={"end"}
        >
          <Offcanvas.Header closeButton="closeButton" closeVariant="white">
            <Offcanvas.Title>
              <div className="d-flex">
                <div className="profile-img">
                  <img src={UserIcon} alt="User Icon" />
                </div>
                <div className="user-info">
                  <Link className="user_name" to="/profile">
                    {user?.mstruserid}
                  </Link>
                  <p>{user?.mobileno}</p>
                </div>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container upperbalnace">
              <div className="row">
                <div className="col-6">
                  <div className="balance mb-4">
                    <WalletIcon />
                    Balance
                  </div>
                </div>
                <div className="col-6">
                  <div className="balance-amount mb-4">
                    BDT {wallet?.balance}
                  </div>
                </div>
                {/* <div className="col-12">
                  <div className="non_cash_balance">
                    <h6 className="non_cash_balance_heading">
                      <span>
                        <strong> Bonus</strong> <small>Non-Cash-Balance </small>{" "}
                      </span>
                      <span>
                        <strong>{wallet?.coins}</strong>
                      </span>
                    </h6>
                  </div>
                </div> */}
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/depositgatways/withdraw");
                  }}
                >
                  <Button variant="" className="btn_withdraw w-100">
                    Withdraw
                  </Button>
                </div>
                <div
                  className="col-6"
                  onClick={() => {
                    navigate("/depositgatways/deposits");
                  }}
                >
                  <Button variant="primary" className="btn_primary w-100">
                    Deposit
                  </Button>
                </div>
              </div>
            </div>
            <ul className="menu-items">
              {/* <li>
                <a href="/profile">
                  <FaRegUserCircle />
                  <span>Profile</span>
                </a>
              </li> */}
              <li>
                <a href="/mybets">
                  <img src={BetIcon} alt="my bet" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/bonus" className="img_size">
                  <img src={BonusImg} />
                  <span className="bonus-space">Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral" className="img_size">
                  <img src={refferal} />

                  <span className="bonus-space">Referral</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AcStatement} alt="account statement" />
                  <span>Account Statement</span>
                </a>
              </li>

              <li onClick={() => dispatch(logoutUser())}>
                <a href="#">
                  {/* <LogoutIcon /> */}
                  <img src={LogoutIconImg} />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>

            <div className="theme-btn">
              <buton type="button" className="btn" onClick={toggleClass}>
                <img src={MoonLight} alt="moon" className="dark_theme" />
                <img src={SunLight} alt="sun" className="light_theme" />
              </buton>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </header>

      {show1 && <MobLeftbar className="d-md-none" />}
    </>
  );
};

export default HeaderAfterLogin;
